module.exports = __webpack_public_path__ + "static/media/proximanova-sbold-webfont.2c1899fd.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/resources/fonts/proximanova-sbold-webfont.eot
// module id = 156
// module chunks = 0